import { render, staticRenderFns } from "./TopHighestTripSalesToday.vue?vue&type=template&id=594a060c"
import script from "./TopHighestTripSalesToday.vue?vue&type=script&lang=js"
export * from "./TopHighestTripSalesToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports